import makeArrayMethod from "./shared/makeArrayMethod";
export default makeArrayMethod("splice").path;
